module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f0162f213bfedc30557803936e40d928.png";